import React, { useState, useEffect } from 'react';
import { useStore, useSettings } from '../../context/store';
import useUpdateFilter from '../../methods/useUpdateFilter';


export default function FilterMultiselect( props ) {
    const {
        state,
        dispatch,
    } = useStore();

    const toggleFilter = ( event, field, value, children = false ) => {
        if ( 'undefined' !== typeof children && false !== children ) {
            const childrenValues = children.map( child => child.value );

            value += `,${childrenValues.join(',')}`;
        }

        if ( event.target.checked ) {
            dispatch({ 
                type: 'addFilterToList', 
                payload: { 
                    'field': field, 
                    'value': value 
                } 
            })
        } else {
            dispatch({ 
                type: 'removeFilterFromList', 
                payload: { 
                    'field': field,
                    'value': value
                } 
            })
        }
    }

    const isChecked = ( field, value ) => {
        if ( 'undefined' !== typeof state.filters[ field ] ) {
            const list = state.filters[ field ].split(',');

            return list.includes( value );
        } else if ( null === value ) {
            return true;
        }

        return false;
    }

    const pre = 'ygl-filter-multiselect';

    if ( 'undefined' !== props.filter ) {
        const filter = props.filter;

        return (
            <div className={ `ygl-filter ${pre}` }>
                <div className={ `${pre}__title-main` } onClick={ e => props.toggleParentActiveClass(e) }>{ filter.name }</div>
                
                <ul className={ `${pre}__dropdown` }>
                    {filter.options.map( (option, index) => {
                        const hasChildren = 'undefined' !== typeof option.options;

                        let listitemClass = `${pre}-listitem`
                        listitemClass += hasChildren ? ` ${pre}-listitem--has-children` : '';

                        return (
                            <li className={ listitemClass } key={ index }>
                                <label className={ `${pre}-listitem__label` } htmlFor={ `${filter.field}-${index}` }>
                                    <input 
                                        id={ `${filter.field}-${index}` } 
                                        type="checkbox" 
                                        className="sr-only" 
                                        name={ option.value } 
                                        onChange={ e => toggleFilter( e, filter.field, option.value, option.options ) }
                                        checked={ isChecked( filter.field, option.value ) }
                                    />
                                    <div className={ `${pre}-listitem__title` }>{ option.name }</div> 
                                </label>

                                <span onClick={ e => props.toggleParentActiveClass(e, false) }></span>

                                {hasChildren &&
                                    <ul className={ `${pre}-sublist` }>
                                        {option.options.map( (suboption, subindex) => {

                                            return (
                                                <li key={ subindex }>
                                                    <label className={ `${pre}-listitem__label` } htmlFor={ `${filter.field}-${index}-${subindex}` }>
                                                        <input 
                                                            id={ `${filter.field}-${index}-${subindex}` } 
                                                            type="checkbox" 
                                                            className="sr-only" 
                                                            name={ suboption.value } 
                                                            onChange={ e => toggleFilter( e, filter.field, suboption.value ) }
                                                            checked={ isChecked( filter.field, suboption.value ) }
                                                        />
                                                        <div className={ `${pre}-listitem__title` }>{ suboption.name }</div>
                                                    </label>
                                                </li>
                                            )
                                        })}
                                    </ul>
                                }
                            </li>
                        )
                    })}
                </ul>
            </div>
        )
    }

    return '';
}